/**
 * GAME
 */
export const GAME_DIV_ID = 'game-holder';
export const GAME_DIV_CLASSNAME = 'canvas_container absolute_center page_background trap';
export const GAME_WIDTH_DEFAULT = 1280;
export const GAME_HEIGHT_DEFAULT = 720;
export const X_PAD_SCALE = 0.03;
export const Y_PAD_SCALE = 0.02;
export const GAME_LEVEL_IDS = ['1'];
export const GAME_BACKGROUND_COLOR = '0x000000';

/**
export const PATH_BASE = './';
 * PATHS
 */
export const PATH_ASSETS = 'assets/';
export const PATH_BASE = './';
/**
 * STATES
 */
export const STATE_BOOT = 'STATE_BOOT';
export const STATE_LOAD = 'STATE_LOAD';
export const STATE_GAME = 'STATE_GAME';
export const STATE_GAME_INTRO = 'STATE_GAME_INTRO';
export const STATE_CHARACTER_INTRO = 'STATE_CHARACTER_INTRO';
export const STATE_WELCOME = 'STATE_WELCOME';
export const STATE_LEVELEND = 'STATE_LEVELEND';
export const STATE_LEVELLOSE = 'STATE_LEVELLOSE';
export const STATE_GAMEEND = 'STATE_GAMEEND';
export const STATE_GAMEOVER = 'STATE_GAMEOVER';
export const STATE_GAME_COMPLETE = 'STATE_GAME_COMPLETE';
export const STATE_CUTSCENE = 'STATE_CUTSCENE';

/**
 * SAVE DATA
 */
export const DEFAULT_PLAYER_ID = 'PLAYER_ONE';
export const SAVED_PLAYER_DATA_ID = 'slots';
export const SAVED_PLAYER_DATA_PREFIX = 'save';

/**
 * FONTS
 */
export const FONT_TITLE = 'superstarregular';
export const FONT_TITLE_CSS = 'superstar_memesbruh03.css';
export const FONT_BUTTON = 'superstarregular';
export const FONT_BUTTON_CSS = 'superstar_memesbruh03.css';
export const FONT_COPY = 'superstarregular';
export const FONT_COPY_CSS = 'superstar_memesbruh03.css';

/**
 * COLOURS
 */
export const TIMER_TEXT_COLOUR = '#ed1c24';
export const TIMER_SHADOW_COLOUR = '#2d3467';
export const COPY_BLUE = '#2c3468';
export const COPY_BLACK = '#000000';
export const COPY_WHITE = '#ffffff';

export const FONT_COLOUR_SCORE = '#ffd700';
export const FONT_COLOUR_SCORE_HIGH = '#34bbf7';
export const FONT_COLOUR_SCORE_TARGET = '#ffffff';
export const FONT_COLOUR_SCORE_FAIL = '#f62e21';
export const FONT_COLOUR_COPYRIGHT = 'rgba(135,136,138,1)';
export const FONT_COLOUR_CREDITS = 'rgba(135,136,138,1)';
export const FONT_COLOUR_LEVEL_WIN = '#fe9901';
export const FONT_COLOUR_PAUSED = '#ffffff';
export const FONT_COLOUR_STROKE = '#000000';
export const FONT_COLOUR_BLACK = '#000000';

/**
 * OTHER
 */
export const GAME_LOAD_FULL = 'GAME_LOAD_FULL';
export const GAME_LOAD_LAZY = 'GAME_LOAD_LAZY';
export const GAME_LOAD_BATCH = 'GAME_LOAD_BATCH';

/**
 * GAME
 */

export const GAME_ROAD_HEIGHT = 288;
export const GAME_ROAD_WIDTH = 1680;
export const GAME_LANE_HEIGHT = 144;
export const GAME_START_HEIGHT = 0;
export const GAME_END_HEIGHT = 430;
export const GAME_GRID_SIZE = 144;
export const GAME_GRID_START_X = 48;

/**
 * SCREENS
 */

export const SCREEN_WELCOME_WAIT_TIME_MIN = 500;
export const SCREEN_WELCOME_WAIT_TIME_MAX = 2000;

export const SCREEN_LOSE_WAIT_TIME_MIN = 400;
export const SCREEN_LOSE_WAIT_TIME_MAX = 2000;

/**
 * WISETRACK
 */

export const WISETRACK_ID = 'WISETRACK_2956_a50b592e82';
export const WISETRACK_COUNTRY = 'en_GB';
